import { useState, useEffect } from 'react';
import { getBothCourtCasesDetailsByCourtRef } from '../services/api/CasesApi.js';

export const useCourtCaseDetails = (courtRef) => {
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCaseDetails = async (ref) => {
    if (!ref) {
      setCaseData(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const response = await getBothCourtCasesDetailsByCourtRef(ref);
      setCaseData(response.data);
    } catch (err) {
      console.error('Error fetching case details:', err);
      setError(err.response?.data?.message || 'Failed to fetch case details');
      setCaseData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCaseDetails(courtRef);
  }, [courtRef]);

  // Manual refetch function
  const refetch = () => {
    fetchCaseDetails(courtRef);
  };

  return {
    caseData,
    loading,
    error,
    refetch
  };
};